export const getUserFromStorage = () => {
  const storedUser = sessionStorage.getItem("user");
  const storedToken = sessionStorage.getItem("token");

  if (storedUser && storedToken) {
    return {
      user: JSON.parse(storedUser),
      token: storedToken,
    };
  }
  return null;
};

// Utility to save user and token to session storage
export const saveUserToStorage = (user, token) => {
  sessionStorage.setItem("user", JSON.stringify(user));
  sessionStorage.setItem("token", token);
};

// Utility to extract user and token from URL params
export const getUserFromParams = (searchParams) => {
  const userData = searchParams.get("user");
  const userToken = searchParams.get("token");

  if (userData && userToken) {
    const userObject = JSON.parse(decodeURIComponent(userData));
    return { user: userObject, token: userToken };
  }
  return null;
};

// Utility to navigate based on role
export const navigateBasedOnRole = (user, navigate) => {
  if (user.role === "student") {
    navigate("/");
  } else if (user.role === "teacher") {
    navigate("/dashboard");
  } else if (user.role === "admin") {
    navigate("/admin");
  } else if (user.role === "caller") {
    navigate("/caller");
  } else {
    console.error("Unknown role: " + user.role);
    navigate("/login");
  }
};
